import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import PagerSkeleton from "./PagerSkeleton";

type ChipVariant = "tag" | "inlineTitle";

interface AlertsHistoryListSkeletonProps {
  items?: number;
  chipVariant?: ChipVariant;
  titleWidths?: number[];
}

const LINE_HEIGHT = 20;
const CHIP_HEIGHT = 27;
const CHIP_RADIUS = 3;

const TITLE_WIDTHS = [140, 130, 145, 135, 150, 138];
const SUBTITLE_WIDTHS = [190, 165, 205, 175, 195, 180];
const DETAIL_WIDTHS = [230, 260, 210, 245, 225, 255];
const CHIP_WIDTHS = [150, 120, 135, 150, 120, 135];

const LOADER_CLASS = "display-block skeleton-on-highlight-bg";
const ROW_SPACING_CLASS = "padding-y-15 padding-right-20";
const ROW_BORDER_CLASS = "border border-style-solid border-bottom-only border-width-1 border-color-light";

export const AlertsHistoryPaginationSkeleton = () => (
  <PagerSkeleton className="margin-top-15" loaderClassName={LOADER_CLASS} />
);

const LineLoader = ({ width }: Readonly<{ width: number }>) => (
  <ContentLoader className={LOADER_CLASS} height={LINE_HEIGHT} width={width} />
);

const pick = (widths: number[], index: number) => widths[index % widths.length];

export default function AlertsHistoryListSkeleton({
  items = 6,
  chipVariant = "tag",
  titleWidths = TITLE_WIDTHS,
}: Readonly<AlertsHistoryListSkeletonProps>) {
  return (
    <>
      {Array.from({ length: items }, (_, index) => {
        const borderClass = index === items - 1 ? "" : ROW_BORDER_CLASS;

        if (chipVariant === "inlineTitle") {
          return (
            <div key={index} className={`display-flex flex-column gap-5 ${ROW_SPACING_CLASS} ${borderClass}`}>
              <div className="display-flex align-items-start justify-content-between gap-15">
                <span className="text-size-14 text-medium">
                  <LineLoader width={pick(titleWidths, index)} />
                </span>
                <span className="text-color-darker text-size-14">
                  <LineLoader width={pick(SUBTITLE_WIDTHS, index)} />
                </span>
              </div>
              <span className="text-color-gray text-size-14">
                <LineLoader width={pick(DETAIL_WIDTHS, index)} />
              </span>
            </div>
          );
        }

        return (
          <div
            key={index}
            className={`display-flex align-items-start justify-content-between gap-15 ${ROW_SPACING_CLASS} ${borderClass}`}
          >
            <div className="display-flex flex-column gap-5">
              <span className="text-size-14 text-medium">
                <LineLoader width={pick(titleWidths, index)} />
              </span>
              <span className="text-color-gray text-size-14">
                <LineLoader width={pick(SUBTITLE_WIDTHS, index)} />
              </span>
              <span className="text-color-gray text-size-14">
                <LineLoader width={pick(DETAIL_WIDTHS, index)} />
              </span>
            </div>
            <span className="display-inline-block">
              <ContentLoader
                className={LOADER_CLASS}
                height={CHIP_HEIGHT}
                width={pick(CHIP_WIDTHS, index)}
                rx={CHIP_RADIUS}
                ry={CHIP_RADIUS}
              />
            </span>
          </div>
        );
      })}
    </>
  );
}
